import script from "./userFiuTemplates.vue?vue&type=script&setup=true&lang=js"
export * from "./userFiuTemplates.vue?vue&type=script&setup=true&lang=js"

import "./userFiuTemplates.vue?vue&type=style&index=0&id=281b60f7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-281b60f7"]])

export default __exports__